import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Layout from '../components/Layout';
import client from '../api/client';

export default function CheckoutSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [message, setMessage] = useState("");
  const [expiresAt, setExpiresAt] = useState("");

  useEffect(() => {
    const authKey = searchParams.get("authKey");
    const plan = searchParams.get("plan") || "";
    const billingType = searchParams.get("billingType") || "";
    const upgraded = searchParams.get("upgraded");

    // 업그레이드는 이미 처리 완료 상태로 도착
    if (upgraded === "true") {
      const stored = localStorage.getItem("user") ? "local" : "session";
      const u = JSON.parse(localStorage.getItem("user") || sessionStorage.getItem("user") || "{}");
      u.plan = plan;
      if (stored === "local") localStorage.setItem("user", JSON.stringify(u));
      else sessionStorage.setItem("user", JSON.stringify(u));
      setStatus("success");
      return;
    }

    if (!authKey || !plan || !billingType) {
      setStatus("error");
      setMessage("구독 정보가 올바르지 않습니다");
      return;
    }

    client.post("/payment/billing/auth", { auth_key: authKey, plan, billing_type: billingType })
      .then(r => {
        setStatus("success");
        setExpiresAt(r.data.expires_at);
        const stored = localStorage.getItem("user") ? "local" : "session";
        const u = JSON.parse(localStorage.getItem("user") || sessionStorage.getItem("user") || "{}");
        u.plan = plan;
        if (stored === "local") localStorage.setItem("user", JSON.stringify(u));
        else sessionStorage.setItem("user", JSON.stringify(u));
      })
      .catch(e => {
        setStatus("error");
        setMessage(e.response?.data?.detail || "구독 처리 중 오류가 발생했습니다");
      });
  }, []);

  const planLabel: Record<string, string> = { basic: "Basic", pro: "Pro" };
  const billingLabel: Record<string, string> = { monthly: "월간", yearly: "연간" };
  const plan = searchParams.get("plan") || "";
  const billingType = searchParams.get("billingType") || "";

  const s: any = {
    card: { background: "#161B27", border: "0.5px solid #2A3045", borderRadius: 12, padding: 40, textAlign: "center" as const },
    btn: { background: "#00D4AA", border: "none", borderRadius: 8, padding: "12px 32px", color: "#0A1F18", fontSize: 14, fontWeight: 700, cursor: "pointer", marginTop: 24 },
  };

  return (
    <Layout>
      <div style={{ maxWidth: 480 }}>
        <div style={s.card}>
          {status === "loading" && (
            <>
              <div style={{ fontSize: 40, marginBottom: 16 }}>⏳</div>
              <div style={{ color: "#E8ECF4", fontSize: 18, fontWeight: 700 }}>구독 처리 중...</div>
            </>
          )}
          {status === "success" && (
            <>
              <div style={{ fontSize: 40, marginBottom: 16 }}>🎉</div>
              <div style={{ color: "#00D4AA", fontSize: 22, fontWeight: 800, marginBottom: 8 }}>🎁 첫 달 무료 시작!</div>
              <div style={{ color: "#8892A4", fontSize: 14, marginBottom: 4 }}>
                {planLabel[plan]} {billingLabel[billingType]} 플랜 등록이 완료되었습니다
              </div>
              {expiresAt && (
                <div style={{ background: "#0F2A22", border: "1px solid #00D4AA44", borderRadius: 8, padding: "12px 16px", marginTop: 12, marginBottom: 4 }}>
                  <div style={{ color: "#00D4AA", fontSize: 13, fontWeight: 700, marginBottom: 4 }}>30일 무료 이용 중</div>
                  <div style={{ color: "#8892A4", fontSize: 12, lineHeight: 1.7 }}>
                    오늘부터 30일간 무료로 이용하실 수 있습니다.<br />
                    무료 기간 내 언제든지 취소 가능합니다.
                  </div>
                  <div style={{ color: "#4A5568", fontSize: 12, marginTop: 8 }}>
                    첫 결제 예정일: {new Date(expiresAt).toLocaleDateString("ko-KR")}
                  </div>
                </div>
              )}
              <div style={{ color: "#4A5568", fontSize: 12, marginTop: 4 }}>
                구독 확인 이메일이 발송되었습니다
              </div>
              <button style={s.btn} onClick={() => navigate("/dashboard")}>대시보드로 이동</button>
            </>
          )}
          {status === "error" && (
            <>
              <div style={{ fontSize: 40, marginBottom: 16 }}>❌</div>
              <div style={{ color: "#F56565", fontSize: 18, fontWeight: 700, marginBottom: 8 }}>구독 실패</div>
              <div style={{ color: "#8892A4", fontSize: 14 }}>{message}</div>
              <button style={s.btn} onClick={() => navigate("/pricing")}>다시 시도</button>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
}
